export default [{
    path: '/admin/login',
    name: 'Login',
    component: () => import('@/views/login/login'),
    meta: {
      title: '登录页面'
    }
  },
  {
    path: '/admin/store/:store_id',
    name: 'StoreLogin',
    component: () => import('@/views/login/store_login'),
    meta: {
      title: '商户登录',
      keepAlive: false
    }
  },
  {
    path: '/admin/clinic/login/:store_id',
    name: 'ClinicLogin',
    component: () => import('@/views/login/clinic_login'),
    meta: {
      title: '门诊登录',
      keepAlive: false
    }
  },
  {
    path: '/admin/mechanism/login/:store_id',
    name: 'MechanismLogin',
    component: () => import('@/views/login/mechanism_login'),
    meta: {
      title: '机构登录',
      keepAlive: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/login.js